import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

const CustomTooltip = ({ active, payload, label, etiquetaValor = 'Ventas' }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-color-primario text-white px-4 py-2 rounded-lg shadow-lg text-sm">
        <p className="font-medium">{label}</p>
        <p className="text-green-200">
          {etiquetaValor}: ${Number(payload[0].value || 0).toLocaleString()}
        </p>
      </div>
    );
  }
  return null;
};

const GraficoVentasMes = ({
  datos = [],
  dataKey = 'ventas',
  etiquetaValor = 'Ventas',
  titulo = 'Reporte de Ventas',
  badgeTexto = 'Ultimos 7 dias',
  emptyText = 'Sin datos de ventas en los ultimos 7 dias',
  mostrarContenedor = true
}) => {
  const grafico = (
    <>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base font-semibold text-gray-800">{titulo}</h3>
        <span className="text-xs text-gray-400 bg-gray-100 px-3 py-1 rounded-full">
          {badgeTexto}
        </span>
      </div>

      <div className="w-full h-64">
        {datos.length === 0 ? (
          <div className="flex items-center justify-center h-full text-gray-400 text-sm">
            {emptyText}
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={datos} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="colorVentas" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#39806A" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#39806A" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
              <XAxis
                dataKey="dia"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: '#9ca3af' }}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: '#9ca3af' }}
                tickFormatter={(value) => value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value}
              />
              <Tooltip content={<CustomTooltip etiquetaValor={etiquetaValor} />} />
              <Area
                type="monotone"
                dataKey={dataKey}
                stroke="#20453D"
                strokeWidth={2.5}
                fill="url(#colorVentas)"
                dot={{ r: 3, fill: '#20453D', strokeWidth: 0 }}
                activeDot={{ r: 5, fill: '#20453D', stroke: '#fff', strokeWidth: 2 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </>
  );

  if (!mostrarContenedor) return grafico;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
      {grafico}
    </div>
  );
};

export default GraficoVentasMes;
